var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shirt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2875 1.875C12.2875 1.875 11.3977 2.1875 10 2.1875C8.60234 2.1875 7.7125 1.875 7.7125 1.875C7.57189 1.87505 7.43231 1.89882 7.29961 1.94531L1.25 4.0625L1.89961 7.5L3.80898 7.71563C4.04281 7.74209 4.25814 7.85552 4.4122 8.03339C4.56627 8.21126 4.6478 8.44057 4.64063 8.67578L4.375 18.125H15.625L15.3594 8.67578C15.3522 8.44057 15.4337 8.21126 15.5878 8.03339C15.7419 7.85552 15.9572 7.74209 16.191 7.71563L18.1004 7.5L18.75 4.0625L12.7004 1.94531C12.5677 1.89882 12.4281 1.87505 12.2875 1.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.0203 2.05664C12.8432 2.72233 12.4511 3.31084 11.9049 3.73066C11.3588 4.15048 10.6892 4.37809 10.0004 4.37809C9.31154 4.37809 8.64199 4.15048 8.09585 3.73066C7.54972 3.31084 7.1576 2.72233 6.98047 2.05664",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.21597b434cb9bf87fa664eebc083f52e.svg";
export { ForwardRef as ReactComponent };